import { calcDate } from '@/util/date.js';
import store from '@/store';
export default {
  height: 'auto',
  calcHeight: 30,
  tip: false,
  searchShow: true,
  searchSpan: 6,
  searchMenuSpan: 6,
  border: true,
  index: true,
  viewBtn: false,
  editBtn: false,
  delBtn: false,
  addBtn: false,
  selection: false,
  dialogClickModal: false,
  searchLabelWidth: 100,
  rowKey: 'index',
  column: [
    // {
    //   label: '主键id',
    //   prop: 'id',
    //   type: 'input',
    //   addDisplay: false,
    //   editDisplay: false,
    //   viewDisplay: false,
    //   hide: true,
    // },
    {
      label: '进件编号',
      prop: 'businessCode',
      type: 'input',
      search: true,
      searchOrder: 995,
      minWidth: 120,
    },
    {
      label: '所属代理商',
      prop: 'businessDeptName',
      type: 'input',
      minWidth: 120,
    },
     {
      label: '所属代理商',
      prop: 'businessDeptIdList',
      type: 'select',
      search: true,
      searchOrder: 994,
      hide: true,
      filterable:true,
      searchMultiple: true,
      dicData: store.getters.companies,
      props: {
        label: 'title',
        value: 'id',
      },
    },
    {
      label: '产品类型',
      prop: 'rentType',
      type: 'select',
      minWidth: 120,
      search: true,
      searchOrder: 993,
      dicData: store.getters.porductTypes,
    },
    // {
    //   label: '产品类型',
    //   prop: 'rentTypeList',
    //   type: 'select',
    //   hide: true,
    //   search: true,
    //   searchMultiple: true,
    //   searchOrder: 993,
    //   dicData: store.getters.porductTypes,
    //   minWidth: 120,
    // },
    {
      label: '租赁人',
      prop: 'name',
      type: 'input',
      search: true,
      minWidth: 100,
      searchOrder: 992,
    },
    {
      label: '手机号',
      prop: 'phoneNumber',
      type: 'input',
      minWidth: 120,
      search: true,
      searchOrder: 991,
    },
    {
      label: '租赁金额',
      prop: 'lendingAmount',
      type: 'input',
      minWidth: 120,
    },
    {
      label: '每月租金',
      prop: 'lendingAmountPer',
      type: 'input',
      minWidth: 120,
    },
    {
      label: '车牌号',
      prop: 'carFirstNumber',
      type: 'input',
      search: true,
      minWidth: 100,
      searchOrder: 990,
    },
    {
      label: '逾期天数',
      prop: 'delayDays',
      type: 'input',
      minWidth: 80,
    },
    {
      label: '提交时间',
      prop: 'logCreateTime',
      type: 'input',
      minWidth: 160,
    },
  ],
};
